import axios from 'axios'
import Util from '@/assets/libs/util'
import convert from 'xml-js'

const _getPerifericosURI = () => {
    return Util.getLocalConfigs('urlPerifericos')
}

const normalizeForXmlJs = (obj) => {
    /*
        Função responsável por normalizar o objeto para o formato XML-JS
    */
    if (obj === null || obj === undefined || obj === '') {
        return { _text: '' }
    }

    if (Array.isArray(obj)) {
        return obj.map(item => normalizeForXmlJs(item))
    }

    if (typeof obj === 'object') {
        const keys = Object.keys(obj)

        // objeto vazio vira <tag></tag>
        if (keys.length === 0) {
            return { _text: '' }
        }

        // percorre recursivamente
        const normalized = {}
        for (const key of keys) {
            normalized[key] = normalizeForXmlJs(obj[key])
        }
        return normalized
    }

    // valores normais permanecem
    return obj
}

export default {
    perifericosURI: _getPerifericosURI(),

    postRequest: async function (uri, dataObject = {}, method = 'post') {
        const backAdress = Util.getBackAdress()
        const isOracle = Util.isOracle()
        let url = isOracle ? Util.getLocalConfigs('urlOdhenInterface') : `${backAdress}/${uri}`
        const knownInterfaceRquest = ['/', 'menu/getPosTefData', 'menu/getPayments', 'v3/menu/getBloqProducts', 'menu/getProdAvailabilityPerHour', 'sale/getOrderData',
            'sale/splitOrders', 'sale/getOrderData', 'sale/joinOrders', 'menu/addBloqProducts', 'menu/removeBloqProducts', 'menu/getProductObservations', 'menu/getProductCombos',
            'pos/close', 'sale/sendingDanfeByEmail', 'sale/getStorePrinters', 'menu/getProductsPrinterParams', 'v3/sale/saveDeliverySaleEx',
            'sale/closeOrder', 'sale/getSale', 'sale/cancelOrder', 'sale/cancelPayments', 'sale/cancelSale', 'sale/savePayment', 'sale/cleanOrder', 'sale/editServiceTax',
            'consumer/login', 'sale/editConsumer', 'menu/getDifferentiatedPrice', 'consumer/buyCredit', 'consumer/registerConsumerPass', 'menu/getWeightProducts', 'login',
            'sale/getSalesHistoryByPos', 'sale/couponReprint', 'menu/offers', 'menu/offersByCombinations', 'sale/getCampaign', 'consumer/getByPhone', 'sale/registerDigitalPager',
            'menu/getProduct', 'sale/saveOrder', 'v3/menu/getByPosExFull', 'login/getSubsidiaries', 'menu/syncCachedImages', 'menu/getCustomTaaConfigurations', 'sale/finishOrder',
            'sale/printCancel', 'consumer/getProductLimit', 'sale/validateGeneralParams', 'menu/taxValidation', 'menu/taxValidation', 'sale/getStatusTable', 'sale/openTable', 'menu/getSubgroupDiscounts',
            'menu/suggestions']

        const interfaceRequest = knownInterfaceRquest.includes(uri)
        const posCode = dataObject.posCode !== undefined ? dataObject.posCode : ((Util.getLocalConfigs('curtaa') && Util.getLocalConfigs('curtaa').posCode) || '')

        if (interfaceRequest && !isOracle) {
            url = `${backAdress}/requestinterface`
            dataObject = {
                ...dataObject,
                interfaceURI: uri,
                device: 'TAA',
                posCode: posCode
            }
        }
        method = method === 'parent' ? 'post' : method
        if (interfaceRequest && isOracle) {
            url = uri === '/' ? `${url}` : `${url}${uri}`
            dataObject = {
                ...dataObject,
                interfaceURI: uri,
                device: 'TAA',
                posCode: posCode
            }
        }

        const postReturn = await axios({
            method: method,
            url,
            data: dataObject,
            timeout: 5 * 60 * 1000
        }).then(successResponse => {
            return (successResponse && successResponse.data) || successResponse
        }).catch(axiosResponse => {
            throw axiosResponse
        })

        return postReturn
    },
    curlRequest: function (url, dataObject = {}, testURLPerifericos) {
        if (url === '/print' && Util.isAndroidMode() && window.PrinterIntegration) {
            try {
                let androidPrinterResponse = window.PrinterIntegration.printText(JSON.stringify({
                    ...dataObject
                }))

                if (androidPrinterResponse) androidPrinterResponse = JSON.parse(androidPrinterResponse)
                if (androidPrinterResponse && !androidPrinterResponse.error) {
                    return Promise.resolve({data: true})
                } else {
                    return Promise.resolve({error: true})
                }
            } catch (error) {
                console.log('Printer Not Found')
                console.log(error)
                return Promise.resolve({error: true})
            }
        }

        // testURLPerifericos só chegará aqui sendo !== null quando se tratar de uma impressão de teste, disparada da
        // tela de Configs. Nesse caso pode ainda não haver uma URL de Perifericos configurada em this.perifericosURI e
        // será utilizada a URL que está no campo de input da tela de Configs
        let perifericosURI = testURLPerifericos || this.perifericosURI
        /* if (url == '/print') {
            // se um dia preciar de mandar somente a impressão para outro perifericos (teste)
            perifericosURI = 'http://10.250.0.235:3000/'
        } */
        return axios.post(perifericosURI + url, dataObject, {
            compress: true}
        )
            .then(response => {
                return response
            })
            .catch(function (error) {
                Util.logComunication(url, error, 'Falha de comunicacao com o perifericos')
                return {
                    error: true,
                    message: 'perifericos'
                }
            })
    },
    conectionStatus: async function (ipServer, timeout) {
        let url = `http://${ipServer}:1812/conectionStatus`
        // eslint-disable-next-line no-return-await
        return await axios({
            method: 'post',
            url,
            data: {},
            timeout: timeout
        }).then(response => {
            return response
        }).catch((e) => {
            console.log(e)
        })
    },
    xmlRequest: async function (url, method, requestBody = null, headers = null) {
        let logUri = `XML Request ERROR: ${url} \n`
        let logPayload = ''
        let logResponse = ''
        if (requestBody) {
            requestBody = normalizeForXmlJs(requestBody)
            requestBody = convert.json2xml(requestBody, {compact: true, spaces: 0})
            requestBody = '<?xml version="1.0"?>\r\n' + requestBody
        }
        logPayload += `${requestBody}\n`
        headers = headers ? {'Content-Type': 'application/xml', ...headers} : {'Content-Type': 'application/xml'}

        const config = {
            method: method,
            url: url,
            data: requestBody,
            headers: {
                ...headers
            },
            timeout: 1 * 15 * 1000,
            maxBodyLength: Infinity
        }
        let result = await axios(config).then((r) => r.data).catch(axiosResponse => {
            return {
                error: true,
                message: (axiosResponse.response && axiosResponse.response.data) || axiosResponse
            }
        })
        logResponse += `${result}\n`

        if (result && !result.error) {
            try {
                result = convert.xml2js(result, {ignoreDeclaration: true, compact: true})
            } catch (error) {
                Util.logComunication(logUri, logPayload, logResponse, true)
                result = {
                    error: true,
                    message: 'Não foi possivel ober o xml de retorno'
                }
            }
            return result
        }
        if (result.error) {
            Util.logComunication(logUri, logPayload, logResponse, true)
            try {
                result.message = convert.xml2js(result.message, {ignoreDeclaration: true, compact: true})
            } catch (error) {
                result = {
                    error: true,
                    message: result.message || 'Não foi possivel interpretar o xml de retorno'
                }
            }
            return result
        }
    },
    externalRequest: async function (url, headers = {}, requestBody, method) {
        const requestOptions = {
            responseType: 'json'
        }
        return axios({
            method,
            url: url,
            data: requestBody,
            // timeout,
            headers: {
                ...headers
            },
            ...requestOptions
        })
            .then(successResponse => {
                return (successResponse && successResponse.data) || successResponse
            })
            .catch(axiosResponse => {
                console.log(axiosResponse)
                throw axiosResponse
            })
    }
}



// WEBPACK FOOTER //
// ./src/assets/libs/requestModule.js